import { render, staticRenderFns } from "./logincomponent.vue?vue&type=template&id=1db02662&scoped=true"
import script from "./logincomponent.vue?vue&type=script&lang=js"
export * from "./logincomponent.vue?vue&type=script&lang=js"
import style0 from "./logincomponent.vue?vue&type=style&index=0&id=1db02662&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db02662",
  null
  
)

export default component.exports